/** Chunk lazy que sumiu do servidor: um deploy aconteceu e esta aba ainda
 *  aponta para arquivos do build anterior. O texto do erro varia por browser. */
export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return /dynamically imported module|importing a module script failed|error loading dynamically imported module|ChunkLoadError/i.test(
    message,
  );
}
